import { TAvailableLanguageCode } from './../../../../../components/LangSelect/types/availableLanguages';
import { AppThunk } from 'store';
import * as storageLocale from 'i18n/storageLocale';

import slice from '../../reducer/slice';

const { setLocale } = slice.actions;

type TOperation = (locale: TAvailableLanguageCode) => AppThunk;

const operation: TOperation = (locale) => async (dispatch) => {
  dispatch(setLocale(locale));
  storageLocale.setLocale(locale);
};
export default operation;
